import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'

class Waypoint extends Component {

  _distanceToTopOfScrollableAncestor = (node) => {
    //console.log('*** node = ', node.offsetParent)
    // if (!this.scrollableAncestor !== window && !node.offsetParent) {
    //   throw new Error('The scrollable ancestor of Waypoint needs to have positioning to ' + 'properly determine position of Waypoint (e.g. `position: relative;`)');
    // }
    if (node.offsetParent === this.scrollableAncestor || !node.offsetParent) {
        return node.offsetTop
    } else {
        return node.offsetTop + this._distanceToTopOfScrollableAncestor(node.offsetParent)
    }
  }

  getCurrentPosition = () => {
    const { threshold, onUpdate } = this.props
    const waypointTop = this._distanceToTopOfScrollableAncestor(findDOMNode(this))

    const contextHeight = window.innerHeight
    const contextScrollTop = window.pageYOffset

    const thresholdPx = contextHeight * threshold;

    const isBelowTop = contextScrollTop <= waypointTop + thresholdPx;
    if (!isBelowTop) return 'above'

    const contextBottom = contextScrollTop + contextHeight;
    const isAboveBottom = contextBottom >= waypointTop - thresholdPx;
    if (!isAboveBottom) return 'below'
    if (onUpdate) onUpdate.call(this, { scrollTop: contextScrollTop, height: contextHeight, waypointTop: waypointTop })
    return 'inside'
  }

  handleScroll = (event) => {
    const currentPosition = this.getCurrentPosition()
    if (this.previousPosition === currentPosition) return
    if (currentPosition === 'inside') {
        if (this.props.onEnter) this.props.onEnter(event)
    } else if (this.previousPosition === 'inside') {
        if (this.props.onLeave) this.props.onLeave(event)
    }
    const isRapidScrollDown = this.previousPosition === 'below' && currentPosition === 'above'
    const isRapidScrollUp = this.previousPosition === 'above' && currentPosition === 'below'
    if (isRapidScrollDown || isRapidScrollUp) {
      if (this.props.onEnter) this.props.onEnter(event)
      if (this.props.onLeave) this.props.onLeave(event)
    }
    this.previousPosition = currentPosition
  }

  componentDidMount() {
    this.scrollableAncestor = window
    this.scrollableAncestor.addEventListener('scroll', this.handleScroll, false)
    window.addEventListener('resize', this.handleScroll, false)
    this.handleScroll()
  }

  componentWillUnmount() {
    if (this.scrollableAncestor) {
      this.scrollableAncestor.removeEventListener('scroll', this.handleScroll, false)
    }
    window.removeEventListener('resize', this.handleScroll, false)
  }

  componentDidUpdate() {
    this.handleScroll()
  }

  render() {
    return (
      <span className="Waypoint" style={{width: 0, height: 0, display: 'inline-block'}}></span>
    )
  }
}

export default Waypoint


// WEBPACK FOOTER //
// ./src/components/Waypoint/index.js